import React, { useState } from 'react'
import '../SearchBar.css'
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';

function SearchBar({ hideButtons = false, autoFocus = true }) {
    const[{term}, dispatch] = useStateValue();
    const [input, setInput] = useState(term || '');
    const navigate = useNavigate();
    function search(event) {
        event.preventDefault();
        dispatch({
            type: actionTypes.SET_SEARCH_TERM,
            term: input
        })
        //
            navigate('/search');
    }
  return (
    <form className='searchbar' onSubmit={(event) => search(event)}>
        <div className="search__input">
            <SearchIcon className="search__inputIcon" / >
            <input value={input} onChange={event => setInput(event.target.value)}type="search" name="q" id="search" className="search__inputBar" autoFocus={autoFocus} />
            <MicIcon />
        </div>
        {!hideButtons && 
        <div className="search__buttons">
            <Button type="submit" variant="outlined">Google Search</Button>
            <Button variant="outlined">I'm Feeling Lucky</Button>
        </div>}
    </form>
  )
}

export default SearchBar
